<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="zaprosInfo"
          @click="visible = 'zapros'"
          :class="visible === 'zapros' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Запрос на котировку</span>
        <span 
          v-if="obshayaInfo"
          @click="visible = 'obshaya'"
          :class="visible === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Общая информация</span>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
        <span 
          v-if="timelinePostavki"
          @click="visible = 'graph'"
          :class="visible === 'graph' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Таймлайн поставки</span>
      </b-container>

      <div v-show="visible === 'zapros'">
        <b-card>
          <b-container fluid>
            <template v-if="detailedItem.quotation && detailedItem.quotation.data">
                <OrderServiceDeliveryQuotationInfo 
                    :quotation="detailedItem.quotation"
                    :showAnswers="true"
                />
            </template>
            <template v-else>
                <div style="font-style: italic; padding: 25px 15px">Запрос на котировку не составлялся.</div>
            </template>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'obshaya'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="6" md="2">
                    <label for="nomer_of_dogovor">Номер договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['0'].value" size="sm" placeholder="" :disabled="true"></b-form-input>
                    <template v-if="editMode && filteredDocs.length > 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Выберите договор:</div>
                      <div 
                          v-for="doc in filteredDocs" 
                          @click="changeSelectedDoc(doc)"
                          :key="doc.id"
                          class="docSelectLinks"
                      >
                          {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                      </div>
                    </template>                                        
                    <template v-if="editMode && filteredDocs.length == 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Добавьте в компанию <br />хотя бы один договор ТЭО!</div>
                    </template>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label for="data_of_dogovor">Дата договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['1'].value" type="date" size="sm" placeholder="" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Наименование груза, код ТНВЭД:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['name_of_cargo']" name="name_of_cargo" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="import_export">Импорт / Экспорт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select 
                      v-model="editedData['import_export']" 
                      name="import_export" 
                      size="sm" 
                      placeholder="" 
                      :options="[
                        { value: 'Импорт', text: 'Импорт' },
                        { value: 'Экспорт', text: 'Экспорт' }
                      ]"
                      :disabled="!localEditMode"
                    ></b-form-select>
                  </b-col>
                </b-row>                
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="usloviya_postavki_id">Условие поставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <tsoft-select-of-properties
                      :reference_id="68"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['usloviya_postavki_id']"
                      index="usloviya_postavki_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                  <b-col sm="2">
                    <label for="naselenniy_punkt">Населенный пункт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['naselenniy_punkt']" name="naselenniy_punkt" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid class="mt-3">
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_sender_name">Грузоотправитель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_sender_name']" name="cargo_sender_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_o">Адрес ГО:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_o']" name="address_g_o" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="mesto_pogruzki_strana">Место погрузки:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['mesto_pogruzki_strana']" name="mesto_pogruzki_strana" size="sm" placeholder="Введите страну" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['mesto_pogruzki_gorod']" name="mesto_pogruzki_gorod" size="sm" placeholder="Введите город" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_shipment">Контактное лицо на погрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_shipment']" name="contact_name_on_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_recipient_company_id">Грузополучатель:</label>
                  </b-col>
                  <b-col sm="10">
                    <tsoft-select-company
                      :needNullElement="true"
                      :selected="editedData['cargo_recipient_company_id']"
                      :disabled="!localEditMode"
                      @set="setCompanyRecipientOfOrder"
                    ></tsoft-select-company>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="inn_g_p">ИНН/КПП:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['inn_g_p']" name="inn_g_p" size="sm" placeholder="Введите ИНН" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['kpp_g_p']" name="kpp_g_p" size="sm" placeholder="Введите КПП" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_p">Адрес ГП:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_p']" name="address_g_p" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_of_unloading_town">Адрес разгрузки:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['address_of_unloading_town']" name="address_of_unloading_town" size="sm" placeholder="Введите город" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['address_of_unloading_street']" name="address_of_unloading_street" size="sm" placeholder="Введите улицу" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_unloading">Контактное лицо на разгрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_unloading']" name="contact_name_on_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="svh_id">СВХ и адрес доставки для таможенного оформления:</label>
                  </b-col>
                  <b-col sm="5">
                    <tsoft-select-of-properties
                      :reference_id="5"
                      :needNullElement="true"
                      :needGroups="true"
                      :disabled="!localEditMode"
                      :selected="editedData['svh_id']"
                      index="svh_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['svh_full_address']" name="svh_full_address" size="sm" placeholder="Введите адрес доставки для ТО" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>

              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="2">
                <label for="perevozchik_id">Перевозчик:</label>
              </b-col>
              <b-col sm="10">
                <tsoft-select-company
                  :needNullElement="true"
                  :selected="editedData['perevozchik_id']"
                  :disabled="!localEditMode"
                  :additionalGetParams="`&is_transport_company=1&checked_id=444`"
                  @set="setCompanyPerevozchikOfOrder"
                ></tsoft-select-company>
              </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col sm="0" md="2"></b-col>
                <b-col sm="12" md="5">                
                  <b-row class="my-2">
                    <b-col sm="4">
                      <label for="perevozchik_name">Перевозчик. Наименование:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-input 
                          v-model="editedData['perevozchik_name']" 
                          name="perevozchik_name" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" md="5">
                  <b-row class="my-2">
                    <b-col sm="4">
                      <label for="perevozchik_inn">Перевозчик. ИНН:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-input 
                          v-model="editedData['perevozchik_inn']" 
                          name="perevozchik_inn" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="my-2">
                <b-col sm="0" md="2"></b-col>
                <b-col sm="12" md="10">
                  <b-row class="my-2">
                    <b-col sm="2">
                      <label for="perevozchik_uridicheskiy_address">Перевозчик. Юр. адрес:</label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input 
                          v-model="editedData['perevozchik_uridicheskiy_address']" 
                          name="perevozchik_uridicheskiy_address" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
          </b-container>            
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="2">
                <label for="pogran_perehod_id">Погран переход:</label>
              </b-col>
              <b-col sm="10">
                <tsoft-select-of-properties
                  :reference_id="73"
                  :needNullElement="true"
                  :disabled="!localEditMode"
                  :selected="editedData['pogran_perehod_id']"
                  index="pogran_perehod_id"
                  @set="setReferenceValue"
                ></tsoft-select-of-properties> 
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row>
              <b-col sm="12" class="d-flex" style="flex-direction: row; justify-content: space-between; align-content: center; align-items: center;">
                <h5 class="my-0 py-0">Транспорт</h5>
                <button  
                  v-if="localEditMode"
                  class="btn btn-sm btn-outline-secondary" 
                  @click="addTs()"
                >Добавить ТС <i class="fas fa-plus ml-1"></i></button>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row 
              class="my-2 one-transport"
              style="align-items: baseline;"
              v-for="(one_ts, ts_index) in editedData['transports']"
              :key="`transport_${ts_index}`"
            >
              <b-col sm="2">
                <label for="containers">ТС {{ ts_index + 1 }}:</label>
                <div v-if="ts_index != 0">
                  <button 
                    :disabled="!localEditMode" 
                    class="btn btn-sm btn-outline-secondary" 
                    @click="deleteTs(ts_index)">Убрать<i class="far fa-trash-alt ml-2"></i></button>
                </div>
              </b-col>
              <b-col sm="10">
                <b-row class="my-2">
                  <b-col sm="12" md="6">
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="nomer_of_tyagach">№ Тягача:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['nomer_of_tyagach']" name="nomer_of_tyagach" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="nomer_of_pricep">№ Прицепа:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['nomer_of_pricep']" name="nomer_of_pricep" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="type_of_auto_id">Тип авто:</label>
                      </b-col>
                      <b-col sm="8">
                        <tsoft-select-of-properties
                          :reference_id="72"
                          :needNullElement="true"
                          :disabled="!localEditMode"
                          :selected="one_ts['type_of_auto_id']"
                          :index="`transports.${ts_index}.type_of_auto_id`"
                          :key="`transport_type_${ts_index}`"
                          @set="setReferenceValue"
                        ></tsoft-select-of-properties>  
                      </b-col>
                    </b-row>
                    <!-- Если выбрана Сборка - убираем блок -->
                    <b-row class="my-2" v-if="one_ts['type_of_auto_id'] && one_ts['type_of_auto_id'] != 879">
                      <b-col sm="4">
                        <label for="volume_of_auto">Вместимость авто, м<sup>3</sup>:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['volume_of_auto']" type="number" name="volume_of_auto" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <!-- Если выбран Рефрижератор - добавляем блок -->
                    <b-row class="my-2" v-if="one_ts['type_of_auto_id'] == 876">
                      <b-col sm="4">
                        <label for="temp_of_auto_min">Диапазон температур, &deg;C:</label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input v-model="one_ts['temp_of_auto_min']" type="number" name="temp_of_auto_min" size="sm" placeholder="От..." :disabled="!localEditMode"></b-form-input>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input v-model="one_ts['temp_of_auto_max']" type="number" name="temp_of_auto_max" size="sm" placeholder="До..." :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="6">
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="number_of_places">Кол-во мест:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['number_of_places']" type="number" name="number_of_places" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="weight">Вес, кг.:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['weight']" type="number" name="weight" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="volume">Объем, м<sup>3</sup>:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_ts['volume']" type="number" name="volume" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="12" class="d-flex" style="flex-direction: row; justify-content: space-between; align-content: center; align-items: center;">
                    <h6 class="my-0 py-0">CMR в ТС {{ ts_index + 1 }}</h6>
                    <button  
                      v-if="localEditMode"
                      class="btn btn-sm btn-outline-secondary" 
                      @click="addCMR(ts_index)"
                    >Добавить CMR <i class="fas fa-plus ml-1"></i></button>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="12">
                    <b-row
                      v-for="(one_cmr, cmr_index) in one_ts.cmrs"
                      class="my-1 position-relative one-cmr"
                      :key="`transport_${ts_index}_cmr_${cmr_index}`"
                    >
                      <b-col sm="12">
                        <b-row class="my-2">
                          <b-col sm="12" md="6">
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="nomer_of_cmr">№ CMR {{ cmr_index + 1 }}:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_cmr['nomer_of_cmr']" name="nomer_of_cmr" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col sm="12" md="6">
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="data_pogruzki_cmr">Дата погрузки:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_cmr['data_pogruzki_cmr']" name="data_pogruzki_cmr" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <div 
                        v-if="cmr_index != 0"
                        class="delete-one-cmr" 
                      >
                        <button 
                          :disabled="!localEditMode" 
                          class="btn btn-sm btn-outline-secondary" 
                          @click="deleteCMR(ts_index, cmr_index)"
                        ><i class="far fa-trash-alt"></i></button>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>   
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md">
                      <b-list-group-item variant="secondary">
                        <span class="small-description">условия поставки</span>
                        {{ nameByPropId(editedData.usloviya_postavki_id) || '<Укажите условия поставки>' }} / {{ takeTypeOfAuto(editedData.transports) || '<Укажите тип авто>' }}
                      </b-list-group-item>
                      <b-list-group-item variant="secondary">
                        <span class="small-description">адрес погрузки</span>
                        {{ editedData.naselenniy_punkt || '<Укажите населенный пункт>' }}
                      </b-list-group-item>
                      <b-list-group-item variant="secondary">
                        <span class="small-description">адрес погрузки</span>
                        {{ editedData.naselenniy_punkt || '<Укажите населенный пункт>' }}
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['pribitie_na_pp_plan'], editedData['pribitie_na_pp_fact'])">
                        <span class="small-description">погран переход</span>
                        {{ nameByPropId(editedData.pogran_perehod_id) || '<Укажите погран переход>' }}<br>
                        <small>{{ editedData['pribitie_na_pp_fact'] || editedData['pribitie_na_pp_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['pribitie_na_svh_plan'], editedData['pribitie_na_svh_fact'])">
                        <span class="small-description">СВХ станция прибытия</span>
                        {{ nameByPropId(editedData.svh_id) || '<Укажите СВХ станцию прибытия>' }}<br>
                        <small>{{ editedData['pribitie_na_svh_fact'] || editedData['pribitie_na_svh_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <span class="small-description">адрес разгрузки</span>
                        {{ editedData.address_of_unloading_town || '<Укажите адрес разгрузки>' }}<br>
                        <small>{{ editedData['dostavka_fact'] || editedData['dostavka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="4" class="text-center">
                    План
                  </b-col>
                  <b-col sm="4" class="text-center">
                    Факт
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="gotovnost_gruza_plan">Готовность груза:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_plan']" 
                        name="gotovnost_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_fact']" 
                        name="gotovnost_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="editedData['cargo_sender_name']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_sender_name']" class="bx bx-x text-danger mr-2"></i>
                                        Грузоотправитель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_o']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_o']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГО
                                    </div>
                                    <div>
                                        <i v-if="editedData['mesto_pogruzki_strana'] && editedData['mesto_pogruzki_gorod']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['mesto_pogruzki_strana'] || !editedData['mesto_pogruzki_gorod']" class="bx bx-x text-danger mr-2"></i>
                                        Место погрузки
                                    </div>                                    
                                    <div>
                                        <i v-if="editedData['contact_name_on_shipment']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_shipment']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на погрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['inn_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['inn_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Грузополучатель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГП
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_of_unloading_town'] && editedData['address_of_unloading_street']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_of_unloading_town'] || !editedData['address_of_unloading_street']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес разгрузки
                                    </div>
                                    <div>
                                        <i v-if="editedData['contact_name_on_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на разгрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['perevozchik_name'] &&
                                                 editedData['perevozchik_inn'] &&
                                                 editedData['perevozchik_uridicheskiy_address']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['perevozchik_name'] ||
                                                 !editedData['perevozchik_inn'] ||
                                                 !editedData['perevozchik_uridicheskiy_address']" class="bx bx-x text-danger mr-2"></i>
                                        Данные по перевозчику
                                    </div>
                                    <div>
                                        <i v-if="editedData['pogran_perehod_id']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['pogran_perehod_id']" class="bx bx-x text-danger mr-2"></i>
                                        Данные погран перехода
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        В документах «Заявка на перевозку»
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления готовности груза, заполните поля, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pogruzka_gruza_plan">Погрузка:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_gruza_plan']" 
                        name="pogruzka_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_gruza_fact']" 
                        name="pogruzka_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        Заявка на перевозку
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId353" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId353" class="bx bx-x text-danger mr-2"></i>
                                        Страховой полис
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления погрузки, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pribitie_na_pp_plan">Прибытие на ПП:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_pp_plan']" name="pribitie_na_pp_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_pp_fact']" name="pribitie_na_pp_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vyhod_s_pp_plan">Выход с ПП:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_s_pp_plan']" name="vyhod_s_pp_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_s_pp_fact']" name="vyhod_s_pp_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pribitie_na_svh_plan">Прибытие на СВХ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_svh_plan']" name="pribitie_na_svh_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_svh_fact']" name="pribitie_na_svh_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Транзитное время:</label>
                <div>{{ editedData['mesto_pogruzki_gorod'] || '<Укажите место погрузки>' }} - {{ nameByPropId(editedData['svh_id']) || '<Укажите СВХ>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya }}</div>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="zakritie_dostavki_plan">Закрытие доставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_plan']" name="zakritie_dostavki_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_fact']" name="zakritie_dostavki_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="podacha_dt_plan">Подача ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_plan']" name="podacha_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_fact']" name="podacha_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vypusk_dt_plan">Выпуск ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_plan']" name="vypusk_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_fact']" name="vypusk_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Время ТО:</label>
                <div class="bigNumber">{{ time_of_to }}</div>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="dostavka_plan">Доставка до склада клиента:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_plan']" name="dostavka_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_fact']" name="dostavka_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center"></b-col>
            </b-row>

            <hr>
            <b-row class="my-2">
              <b-col sm="12" class="text-center">
                <div class="bigNumber transitItogBlock">Общее транзитное время: {{ obshee_transitnoe_vremya }}</div>
              </b-col>
            </b-row>

          </b-container>
          
        </b-card>
      </div>

      <ActiveHistory
        v-if="visible === 'graph'"
        :serviceIds="detailedItem.id"
      />
    </b-overlay>
  </div>
</template>

<script>
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import ActiveHistory from '@/components/orders/orderServiceTemplate/v2/ActiveHistory';
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    zaprosInfo: {
      type: Boolean,
      default: true,
    },
    obshayaInfo: {
      type: Boolean,
      default: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    timelinePostavki: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'obshaya',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {ActiveHistory, OrderServiceDeliveryQuotationInfo},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'obshaya',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        cargo_sender_name: '',
        address_g_o: '',
        mesto_pogruzki_strana: '',
        mesto_pogruzki_gorod: '',
        contact_name_on_shipment: '',
        cargo_recipient_company_id: null,
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading_town: '',
        address_of_unloading_street: '',
        contact_name_on_unloading: '',
        svh_id: null,
        svh_full_address: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        pogran_perehod_id: null,

        number_of_auto: 1,

        transports: [
          {
            nomer_of_tyagach: '',
            nomer_of_pricep: '',
            number_of_places: 0,
            weight: 0,
            volume: 0,
            type_of_auto_id: null,
            volume_of_auto: 0,    // Не для Сборки (тип авто)
            temp_of_auto_min: '',  // Только для Рефриджераторов (тип авто)
            temp_of_auto_max: '',  // Только для Рефриджераторов (тип авто)
            cmrs: [
              {
                nomer_of_cmr: '',
                data_pogruzki_cmr: '',
              }
            ]
          }
        ],

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        pogruzka_gruza_plan: '',
        pogruzka_gruza_fact: '',
        pribitie_na_pp_plan: '',
        pribitie_na_pp_fact: '', 
        vyhod_s_pp_plan: '',
        vyhod_s_pp_fact: '',
        pribitie_na_svh_plan: '',
        pribitie_na_svh_fact: '',
        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },  
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_na_svh_fact'] || !this.editedData['pogruzka_gruza_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['pribitie_na_svh_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_gruza_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    hasDocumentWithId339() {
        const hasDocumentWithId339 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 339);

        return hasDocumentWithId339;
    },
    hasDocumentWithId353() {
        const hasDocumentWithId353 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 353);

        return hasDocumentWithId353;
    },
    isCanFillGotovnostGruza() {
        return true;
    }
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      let indexArray = index.split('.');
      if (indexArray.length > 1) {
        if (indexArray[0] == 'transports') {
          if (indexArray[2] != 'cmrs') {
            this.editedData[indexArray[0]][indexArray[1]][indexArray[2]] = value;  
          }
        }
      } else {
        this.editedData[index] = value;
      }
    }, 
    setCompanyRecipientOfOrder(value, element) {
      this.editedData['cargo_recipient_company_id'] = value;
      this.editedData['inn_g_p'] = element.inn;
      this.editedData['kpp_g_p'] = element.kpp;
      this.editedData['address_g_p'] = element.address;
    },
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
    addTs() {
      let prevTS = this.editedData['transports'][this.editedData['transports'].length - 1];
      this.editedData['transports'].push(JSON.parse(JSON.stringify(prevTS)));
      this.editedData['number_of_auto']++;
    },
    deleteTs(ts_index) {
      this.editedData['transports'].splice(ts_index, 1);
      this.editedData['number_of_auto']--;
    },
    addCMR(ts_index) {
      let prevCMR = this.editedData['transports'][ts_index]['cmrs'][this.editedData['transports'][ts_index]['cmrs'].length - 1];
      this.editedData['transports'][ts_index]['cmrs'].push(JSON.parse(JSON.stringify(prevCMR)));
    },
    deleteCMR(ts_index, cmr_index) {
      this.editedData['transports'][ts_index]['cmrs'].splice(cmr_index, 1);
    },

  },
};
</script>
<style scoped>
.one-transport {
  background: #f2f2f2;
  border: 1px dashed #0d6247;
}

.one-cmr {
  border-left: 1px solid #CCC;
}
.one-cmr:hover {
  border-left: 1px solid #0d6247;
}
.delete-one-cmr {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 18px;
  left: -45px;
}
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

</style>